import PropTypes from 'prop-types';
import Entity from '../entity/Entity';
import Checkbox from '../../ui/checkbox';
import TooltipHelper from '../tooltip/TooltipHelper';
import { cn } from '@/common-utils/libraries/tailwind/utils';

/**
 *
 * @param root0
 * @param root0.isChecked
 * @param root0.onCheckedChange
 * @param root0.isDisabled
 * @param root0.entity
 * @param root0.hoverEntity
 * @param root0.namespace
 * @param root0.className
 * @returns {JSX} CheckboxHelper
 */
function CheckboxHelper({ isChecked, onCheckedChange, isDisabled, entity, hoverEntity, namespace, className }) {
    const labelClassName = cn('text-sm cursor-pointer', isDisabled && 'text-gray-400 cursor-not-allowed');

    return (
        <div className={cn('flex items-center gap-2', className)}>
            <Checkbox
                className='h-4 w-4 data-[state=checked]:bg-success data-[state=checked]:border-success'
                checked={isChecked}
                onCheckedChange={onCheckedChange}
                disabled={isDisabled}
            />
            {hoverEntity ? (
                <TooltipHelper
                    asChild
                    trigger={
                        <span
                            className={cn('inline-flex', labelClassName)}
                            onClick={!isDisabled ? onCheckedChange : undefined}
                        >
                            <Entity entity={entity} namespace={namespace} />
                        </span>
                    }
                    content={<Entity entity={hoverEntity} namespace={namespace} className='text-sm' />}
                />
            ) : (
                <Entity
                    className={labelClassName}
                    entity={entity}
                    namespace={namespace}
                    onClick={!isDisabled ? onCheckedChange : undefined}
                />
            )}
        </div>
    );
}

CheckboxHelper.propTypes = {
    isChecked: PropTypes.bool.isRequired,
    onCheckedChange: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool.isRequired,
    entity: PropTypes.string.isRequired,
    hoverEntity: PropTypes.string,
    namespace: PropTypes.string.isRequired,
    className: PropTypes.string
};

export default CheckboxHelper;